import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { VehicleAssignmentDto } from './dto/vehicle-assignment.dto';
import {VehicleAssignmentResponseModel} from '@gtpl/shared-models/transportation'
import { VehicleAssignmentService } from './vehicle-assignment.service';
import { ApiTags } from '@nestjs/swagger';
import { IndentRequest } from './dto/indent.request';
import { VehicleNumberReq } from './dto/vehicle-info-req';
import { CommonResponse } from '@gtpl/shared-models/masters';

@ApiTags('VehicleAssignment')
@Controller('vehicle-assignment')
export class VehicleAssignmentController {
    constructor(
        private vehicleAssignmentService: VehicleAssignmentService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
    /**
     * 
     * @param vehicleAssignmentDto 
     * @param isUpdate 
     * @param request 
     * @returns 
     */
    @Post('/createVehicleAssignment')
    async createVehicleAssignment(@Body() vehicleAssignmentDto:VehicleAssignmentDto,isUpdate:boolean=false,@Req() request:Request): Promise<VehicleAssignmentResponseModel> {
        try {
            // console.log(vehicleAssignmentDto);
            return await this.vehicleAssignmentService.createVehicleAssignment(vehicleAssignmentDto, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(VehicleAssignmentResponseModel, error)
        }
    }
    /**
     * 
     * @param indentRequest 
     * @returns 
     */
    @Post('/getVehicleAssignDetailsByIndentId')
    async getVehicleAssignDetailsByIndentId(@Body() indentRequest:IndentRequest): Promise<VehicleAssignmentResponseModel> {
        console.log('jjjjjjjj');
        try {
            return await this.vehicleAssignmentService.getVehicleAssignDetailsByIndentId(indentRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(VehicleAssignmentResponseModel, error)
        }
    }
    @Post('/updateVehicleAssignment')
    async uodateVehicleAssignment(@Body() vehicleAssignmentDto:VehicleAssignmentDto,isUpdate:boolean=true,@Req() request:Request): Promise<VehicleAssignmentResponseModel> {
        try {
            // console.log(vehicleAssignmentDto);
            return await this.vehicleAssignmentService.createVehicleAssignment(vehicleAssignmentDto, isUpdate);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(VehicleAssignmentResponseModel, error)
        }
        
    }
    @Post('/getVehicleAssignDetailsByVehicleNum')
    async getVehicleAssignDetailsByVehicleNum(@Body() request:VehicleNumberReq): Promise<CommonResponse> {
        try {
            // console.log(vehicleAssignmentDto);
            return await this.vehicleAssignmentService.getVehicleAssignDetailsByVehicleNum(request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
}
@Post('/getAssignedVehicleNumbers')
async getAssignedVehicleNumbers(): Promise<CommonResponse> {
    try {
        // console.log(vehicleAssignmentDto);
        return await this.vehicleAssignmentService.getAssignedVehicleNumbers();
    } catch (error) {
        return this.applicationExceptionhandler.returnException(CommonResponse, error)
    }
}
}